module.exports = __webpack_public_path__ + "static/media/berth11.ef2cef30.jpg";